import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import NativeSelect from '@material-ui/core/NativeSelect'

const styles = theme => ({
  fullWidth: {width: '100%'}
})

class DecisionSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      decisionId: ''
    }
  }

  handleChange = event => {
    this.setState({
      decisionId: event.target.value
    }, this.props.onChange(event))
  }

  render() {
    const { decisionId } = this.state
    const { decisions, classes, t } = this.props
    const { handleChange } = this
    const domains = Object.keys(decisions) || []
    return (
      <FormControl className={classes.fullWidth}>
        <NativeSelect
          name="decisionId"
          onChange={handleChange}
          value={decisionId}
        >
          {!decisionId && (
            <option value="">
              {t('Select Decision')}
            </option>
          )}
          {domains.map(domain => {
            return (
              <optgroup
                key={domain}
                label={domain}
              >
                {decisions[domain].map(decision => (
                  <option
                    key={decision.id}
                    value={decision.id}
                  >{decision.decisionName}</option>
                ))}
              </optgroup>
            )
          })}
        </NativeSelect>
      </FormControl>
    )
  }
}

DecisionSelect.propTypes = {
  decisions: PropTypes.object,
  classes: PropTypes.object,
  t: PropTypes.func
}

export default compose(
  translate(),
  withStyles(styles)
)(DecisionSelect)



// WEBPACK FOOTER //
// ./src/components/setup/DecisionSelect.js